import { ERROR_CODE, ERROR_MESSAGE } from "features/ConsultRequest/core/constants";
import { firstGraphQLError, networkStatusOf, parseGraphQLError } from "hooks/apollo/graphqlError";

const UNAUTHENTICATED_CODES = ["UNAUTHENTICATED", ERROR_CODE.UNAUTHORIZED];
// Directive @staffSecured/@permissions của gateway trả errorz.PermissionDenied (không có project_code):
// reason/message là "không có quyền" — quy về FORBIDDEN như REST (ERROR_MESSAGE, RELOAD_ERROR_CODES).
const PERMISSION_DENIED = /không có quyền|permission[\s_]?denied/i;
const hasProjectCode = (gqlError) => (gqlError?.extensions?.details || []).some((item) => item?.metadata?.project_code);
const codeOf = (rawError, parsed) => {
  if (!parsed) return undefined;
  const denied = PERMISSION_DENIED.test(parsed.code || "") || PERMISSION_DENIED.test(parsed.message);
  return !hasProjectCode(rawError) && denied ? ERROR_CODE.FORBIDDEN : parsed.code || undefined;
};

// Lỗi GraphQL (api_gateway): mã nghiệp vụ fulfillment_be nằm ở errors[].extensions.details (ErrorInfo.metadata).
// Chuẩn hóa về shape cũ { code, status, message, errors, data }.
export function parseConsultError(error) {
  const status = networkStatusOf(error);
  const rawError = firstGraphQLError(error);
  const gqlError = parseGraphQLError(rawError);
  if (status === 401 || UNAUTHENTICATED_CODES.includes(gqlError?.code)) {
    return { code: ERROR_CODE.UNAUTHORIZED, status: 401, message: ERROR_MESSAGE.UNAUTHORIZED };
  }
  const code = codeOf(rawError, gqlError);
  return {
    code,
    status,
    message: ERROR_MESSAGE[code] || gqlError?.message || "Không tải được dữ liệu. Vui lòng thử lại.",
    errors: gqlError?.fields || [],
    data: gqlError?.data ?? undefined,
  };
}
